<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper report-search">
      <div>
        <rhcn-datepicker
          v-model="transactionMonth"
          size="small"
          type="month"
          format="yyyy-MM"
          :placeholder="$t('message.tableCommon.creationTime')"
          custom-class="report-date-picker"
          @focus="onDatePickerFocus">
        </rhcn-datepicker>
        <el-button class="margin-left-25" type="primary" size="small" @click="onSearch">{{$t('message.searchCommon.search')}}</el-button>
      </div>
      <el-button v-permission="'report:statement:download'" icon="iconfont icon-Download" size="small" :loading="downloading" @click="handleDownload">{{$t('message.common.download')}}</el-button>
    </div>
    <div class="table-wrapper">
      <custom-table ref="table"
                    :table-set="tableCondition"
                    :service-function="queryList">
      </custom-table>
    </div>
  </div>
</template>
<script>
import RhcnDatepicker from '@/components/form/datepicker.vue';
import { ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import { eventTrackManager } from '@/plugins/eventTrackManager';
import ReportService from '@/views/report/api/report';
export default {
  components: {
    CustomTable,
    RhcnDatepicker,
  },
  data() {
    return {
      transactionMonth: new Date(),
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.creationTime' },
          key: 'month',
          type: 'text',
          textFunc: (data) => `${data.year}.${data.month}`,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.currency' },
          key: 'currency',
          type: 'text',
        },
      ],
      downloading: false,
    };
  },
  methods: {
    async queryList() {
      const params = {
        size: -1,
      };
      if (this.transactionMonth) {
        const date = new Date(this.transactionMonth);
        params.month = date.getMonth() + 1;
        params.year = date.getFullYear();
      }
      return await ReportService.queryList(params);
    },
    onSearch() {
      if (!this.transactionMonth) {
        ShowWarningMessage(this.$t('message.validator.select', { select: this.$t('message.tableCommon.creationTime') }));
        return;
      }
      this.$refs.table.refreshTable();
    },
    async handleDownload() {
      if (!this.transactionMonth) {
        ShowWarningMessage(this.$t('message.validator.select', { select: this.$t('message.tableCommon.creationTime') }));
        return;
      }
      this.downloading = true;
      try {
        const params = {};
        const date = new Date(this.transactionMonth);
        params.month = date.getMonth() + 1;
        params.year = date.getFullYear();
        await ReportService.downloadReport(params);
        ShowSuccessMessage(this.$t('message.common.downloadTask'));
      } catch (err) {
        //
      }
      this.downloading = false;
    },
    onDatePickerFocus() {
      eventTrackManager.send({ e: 'monthlystatement_time' });
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.report-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .rhcn-datepicker {
    width: 280px;
  }

  .icon-Download {
    font-size: 14px;
    margin-right: 4px;
  }
}

.report-date-picker {
  .el-month-table {
    .today {
      .cell {
        color: #606266 !important;
      }
    }
    .current {
      .cell {
        color: #00A2DD !important;
      }
    }
  }
}
</style>
